module.exports = __webpack_public_path__ + "img/playground.3766e02e.jpg";